import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../../../config/constants';

import './style.scss';

const NodeTestimonial = ({ entity, className }) => {
  const { t } = useTranslation();

  const classes = classNames(className, 'Testimonial', 'Testimonial--small');

  const title = entity.getIn(['title', 0, 'value'], '');
  const langcode = entity.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);
  const path = entity.getIn(['paths', langcode], '');
  const author = entity.getIn(['field_author', 0, 'value'], '');
  const role = entity.getIn(['field_role', 0, 'value'], '');
  const quote = entity.getIn(['field_quote', 0, 'value']);

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <CoreLink to={path} className="Testimonial--small__link">
        <q className="asH3">{quote}</q>
        <span className="icon-after icon-arrow icon-variant-1">
          {t(`testimonial.link.${role ? 'with' : 'without'}_role`, {
            author: author || title,
            role: role.toLowerCase(),
          })}
        </span>
      </CoreLink>
    </article>
  );
};


export default NodeTestimonial;
